import FilterTypes from 'redux/filters/types';

/** ****************************
 * Fetch Application admin levels
 ***************************** */

export const startFetchApplicationAdminLevels = (id) => ({
  type: FilterTypes.START_FETCH_APPLICATION_ADMIN_LEVELS,
  payload: id,
});

export const fetchApplicationAdminLevelsSuccess = (data) => ({
  type: FilterTypes.FETCH_APPLICATION_ADMIN_LEVELS_SUCCESS,
  payload: data,
});

export const fetchApplicationAdminLevelsFailure = (error) => ({
  type: FilterTypes.FETCH_APPLICATION_ADMIN_LEVELS_FAILURE,
  payload: error,
});

/** ****************************
 * Fetch admin level courses
 ***************************** */

export const startFetchAdminLevelsCourses = (id) => ({
  type: FilterTypes.START_FETCH_ADMIN_LEVELS_COURSES,
  payload: id,
});

export const fetchAdminLevelsCoursesSuccess = (data) => ({
  type: FilterTypes.FETCH_ADMIN_LEVELS_COURSES_SUCCESS,
  payload: data,
});

export const fetchAdminLevelsCoursesFailure = (error) => ({
  type: FilterTypes.FETCH_ADMIN_LEVELS_COURSES_FAILURE,
  payload: error,
});
